import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BaseComponent } from '@uw/core/base.component';
import { UtilsService } from '@uw/core/services/utils.service';
import { CampaignService } from '@uw/core/services/campaign.service';
import { CampaignStateService } from '@uw/core/services/campaign-state.service';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MyCampaignPageComponent } from '../../../my-campaign/pages/my-campaign-page.component';
import { SafeHtmlPipe } from '../../../../shared/pipes/santized-html.pipe';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    templateUrl: './my-campaign-modal.component.html',
    styleUrls: ['./my-campaign-modal.component.scss'],
    imports: [MatIconButton, MatIcon, MyCampaignPageComponent, MatButton, SafeHtmlPipe, TranslateModule]
})
export class MyCampaignModalComponent extends BaseComponent {
    
  title!:string;
  sideImgSrc!: string | null;
  sideImageAlt!: string | null;  

  constructor(
   
    public campaignService: CampaignService,
    public campaingStateService: CampaignStateService,
    
    public utils: UtilsService,
    @Inject(MAT_DIALOG_DATA) public data: {title: string, sideImgSrc: string, sideImageAlt: string,},
    public dialogRef: MatDialogRef<MyCampaignModalComponent>) {
    super();
    this.title = data.title;
    this.sideImgSrc = data.sideImgSrc ?? 'assets/images/Layer_1.png';
    this.sideImageAlt = data.sideImageAlt ?? '';
    
    
  }


  
  

  

  onCancel(): void {
    this.dialogRef.close();
  }   

}
